import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "columnSpan", "padding", "paddingHorizontal", "paddingLeft", "paddingRight", "paddingVertical", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Box } from '@bubble-ui/layout-box';
import { useActiveValue, useSpace } from '@bubble-ui/hook-use-styles';
import { DEFAULT_COLUMN_SPAN, TOTAL_COLUMNS } from '../constants';
import { GridContext } from '../GridContext';
var GridItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      columnSpan: columnSpanProp = DEFAULT_COLUMN_SPAN,
      padding,
      paddingHorizontal = padding,
      paddingLeft: paddingLeftProp = paddingHorizontal,
      paddingRight: paddingRightProp = paddingHorizontal,
      paddingVertical = padding,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    gapHorizontal: parentGapHorizontal
  } = React.useContext(GridContext);
  var paddingLeft = (parentGapHorizontal + useSpace(paddingLeftProp)) / 2;
  var paddingRight = (parentGapHorizontal + useSpace(paddingRightProp)) / 2;
  var columnSpan = useActiveValue(columnSpanProp);
  var flexBasis = "".concat(columnSpan / TOTAL_COLUMNS * 100, "%");
  return /*#__PURE__*/React.createElement(Box, _extends({
    style: _objectSpread({
      flexBasis
    }, style),
    maxWidth: flexBasis,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingVertical: paddingVertical,
    shrink: true
  }, props, {
    ref: ref
  }), children);
});
GridItem.displayName = 'Grid.Item';
export { GridItem };
//# sourceMappingURL=index.js.map